import * as i18n from "util/i18n";
import { maskedAccountNumber } from "util/account";

export const getAccountsWithChecksEnabled = (accounts) => {
    const availableAccounts = accounts.filter(
        (account) =>
            account.currency === "ARS" &&
            account.accountType === "CC" &&
            account.permissions?.["accounts.requestCheckbook"],
    );
    const options = availableAccounts.map((account) => ({
        balance: { currency: account?.currency, quantity: account?.availableBalance },
        currency: account?.currency,
        frequentDestination: null,
        id: account?.productId,
        label: `${i18n.get(`productType.${account?.accountType}`)} ····${account?.accountNumber?.slice(-4)}`,
        minimumPayment: 0,
        permissions: Object.keys(account?.permissions),
        statementsLoan: null,
        totalPayment: 0,
        type: account?.accountType,
    }));
    return options;
};
